// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'jquery'
import 'fomantic-ui/src/semantic.less'
import 'fomantic-ui/dist/semantic.min.js'
import './assets/css-variables.css'
import Vue from 'vue'
import VueUniqIds from 'vue-uniq-ids'
import Router from 'vue-router'
import SimpleVueValidation from 'simple-vue-validator'
import Vuelidate from 'vuelidate'
import VModal from 'vue-js-modal'
import Storage from 'vue-ls'
import auth from './plugins/auth'
import growl from './plugins/growl'
import idRnd from './plugins/id-rnd'
import productHistory from './plugins/productHistory'
import { plugin as HttpPlugin } from './plugins/http'
import Scroll from './plugins/scroll'
import App from './App.vue'
import router from './router'
import store from './store'
import currency_filter from './filter/currency'
import date_filter from './filter/date'
import default_filter from './filter/default'
import truncate_filter from './filter/truncate'

// Filter registrieren
Vue.filter('money', currency_filter)
Vue.filter('date', date_filter)
Vue.filter('default', default_filter)
Vue.filter('defaultTo', default_filter)
Vue.filter('truncate', truncate_filter)

// Direktiven registrieren
Vue.directive('tooltip', {
    bind(el, binding) {
        $(el).popup({ content: binding.value })
    }
})


// Plugins registrieren
Vue.use(Router)
Vue.use(Vuelidate)
Vue.use(SimpleVueValidation, { mode: 'conservative' })
Vue.use(VModal, { componentName: "v-modal" })
Vue.use(Storage, { namespace: 'zmk_' })
Vue.use(auth)
Vue.use(HttpPlugin)
Vue.use(Scroll)
Vue.use(idRnd)
Vue.use(growl)
Vue.use(productHistory)
Vue.use(VueUniqIds)

/* eslint-disable no-new */
Vue.config.productionTip = false
Vue.config.devtools = false

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
})

// Theme initialisieren
store.dispatch('theme/init')
